// React-хуки для нативных кнопок Telegram (MainButton / BackButton).
//
// Вне Telegram (отладка в браузере) объектов нет — хуки тихо
// бездействуют, поэтому компоненты сохраняют свои обычные кнопки как
// fallback (см. isTelegram()).

import { useEffect, useRef } from "react";

export function isTelegram(): boolean {
  return !!window.Telegram?.WebApp?.initData;
}

// Нативная главная кнопка внизу экрана. Видна, пока примонтирован
// компонент; при размонтировании прячется.
export function useMainButton(opts: {
  text: string;
  onClick: () => void;
  visible?: boolean;
  enabled?: boolean;
  progress?: boolean;
}): void {
  const { text, visible = true, enabled = true, progress = false } = opts;
  const cbRef = useRef(opts.onClick);
  cbRef.current = opts.onClick;

  useEffect(() => {
    const mb = window.Telegram?.WebApp?.MainButton;
    if (!mb) return;
    const handler = () => cbRef.current();
    mb.onClick(handler);
    return () => {
      mb.offClick(handler);
      mb.hideProgress();
      mb.hide();
    };
  }, []);

  useEffect(() => {
    const mb = window.Telegram?.WebApp?.MainButton;
    if (!mb) return;
    mb.setText(text);
    if (enabled) mb.enable();
    else mb.disable();
    if (progress) mb.showProgress();
    else mb.hideProgress();
    if (visible) mb.show();
    else mb.hide();
  }, [text, visible, enabled, progress]);
}

// Нативная кнопка «назад» в шапке Telegram.
export function useBackButton(onClick: () => void, visible = true): void {
  const cbRef = useRef(onClick);
  cbRef.current = onClick;

  useEffect(() => {
    const bb = window.Telegram?.WebApp?.BackButton;
    if (!bb) return;
    const handler = () => cbRef.current();
    bb.onClick(handler);
    return () => {
      bb.offClick(handler);
      bb.hide();
    };
  }, []);

  useEffect(() => {
    const bb = window.Telegram?.WebApp?.BackButton;
    if (!bb) return;
    if (visible) bb.show();
    else bb.hide();
  }, [visible]);
}
